import { render, staticRenderFns } from "./UsageCard.vue?vue&type=template&id=10a131f8"
import script from "./UsageCard.vue?vue&type=script&lang=js"
export * from "./UsageCard.vue?vue&type=script&lang=js"
import style0 from "./UsageCard.vue?vue&type=style&index=0&id=10a131f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports